import { styled } from "solid-styled-components";

export const SortIconWrapper = styled.div`
  position: relative;
  height: 30px;
  width: 30px;
  .left {
    position: absolute;
    left: -5px;
    bottom: 0px;
  }
  .right {
    position: absolute;
    right: -5px;
    top: 0px;
  }
`;
